import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Layout,
      redirect: '/home',
      children: [
        {
          path: '',
          name: 'Home',
          component: () => import('@/views/home/index'),
          meta: { title: 'Home', keepAlive: true }
        },
        {
          path: 'lesson',
          name: 'Lesson',
          component: () => import('@/views/lesson/index'),
          meta: { title: 'Lesson', keepAlive: true }
        },
        {
          path: 'oneStop',
          name: 'oneStop',
          component: () => import('@/views/one-stop/index'),
          meta: { title: 'oneStop', keepAlive: true }
        },
        {
          path: 'stopDetail',
          name: 'stopDetail',
          component: () => import('@/views/one-stop/detail'),
          meta: { title: 'stopDetail', keepAlive: true }
        },
        {
          path: 'shenShuo',
          name: 'shenShuo',
          component: () => import('@/views/shen-shuo/index'),
          meta: { title: 'shenShuo', keepAlive: true }
        },
        {
          path: 'shenDetail',
          name: 'shenDetail',
          component: () => import('@/views/shen-shuo/detail'),
          meta: { title: 'shenShuo', keepAlive: true }
        },
        // {
        //   path: 'lesson1',
        //   name: 'Lesson1',
        //   component: () => import('@/views/lesson/index1'),
        //   meta: {title: 'Lesson'}
        // },
        {
          path: 'free',
          name: 'Free',
          component: () => import('@/views/free/index'),
          meta: { title: 'Free', keepAlive: true }
        },
        {
          path: '/freevideo',
          name: 'Freevideo',
          component: () => import('@/views/video/freevideo'),
          meta: { title: 'Freevideo' }
        },
        {
          path: '/video',
          name: 'Video',
          component: () => import('@/views/lesson/video'),
          meta: { title: 'Video' }
        },
        {
          path: '/teachers',
          name: 'Teachers',
          component: () => import('@/views/lesson/teachers'),
          meta: { title: 'Teachers' }
        },
        {
          path: '/pay',
          name: 'Pay',
          component: () => import('@/views/lesson/pay'),
          meta: { title: 'Pay' }
        },
        {
          path: '/details',
          name: 'Details',
          component: () => import('@/views/lesson/details'),
          meta: { title: 'Details' }
        },
        {
          path: '/learn',
          name: 'Learn',
          component: () => import('@/views/learn/index'),
          meta: { title: 'Learn' }
        },
        {
          path: '/guide',
          name: 'Guide',
          component: () => import('@/views/guide/index'),
          meta: { title: 'Guide' }
        },
        {
          path: '/concerning',
          name: 'Aoncerning',
          component: () => import('@/views/about/index'),
          meta: { title: 'Aoncerning' }
        },
        {
          path: '/info',
          name: 'Info',
          component: () => import('@/views/info/index'),
          redirect: '/info/infolist',
          meta: { title: 'Info' },
          children: [
            {
              path: 'infolist',
              name: 'Infolist',
              component: () => import('@/layout/components/infoList'),
              alias: '/info'
            }
          ]
        },
        {
          path: 'infodetails',
          name: 'Infodetails',
          component: () => import('@/layout/components/infoDetails'),
          alias: '/infodetails'
        },
        {
          path: '/login',
          name: 'Login',
          component: () => import('@/views/login/login')
        },
        {
          path: '/user',
          name: 'User',
          component: () => import('@/views/user/index')
        },
        {
          path: '/live',
          name: 'Live',
          component: () => import('@/views/live/live')
        },
        {
          path: '/liveDetail',
          name: 'LiveDetail',
          component: () => import('@/views/liveDetail/liveDetail')
        },
        {
          path: '/dreamClass',
          name: 'dreamClass',
          component: () => import('@/views/dreamClass/index')
        },
        {
          path: '/unitedExam',
          name: 'unitedExam',
          component: () => import('@/views/unitedExam/index')
        },
        {
          path: '/teacher',
          name: 'teacher',
          component: () => import('@/views/teacher/index'),
          meta: { keepAlive: true }
        },
        {
          path: '/joinUs',
          name: 'joinUs',
          component: () => import('@/views/joinUs/index')
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js